(function () {
  function initSophieNavigation() {
    const header = document.querySelector('.dune-sophie-header');
    if (!header) return;

    const desktopMenus = Array.from(header.querySelectorAll('.header__inline-menu header-menu > details'));

    function closeDesktopMenus(except) {
      desktopMenus.forEach((details) => {
        if (details === except) return;
        details.classList.remove('dune-desktop-drawer-opening');
        details.removeAttribute('open');
        const summary = details.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', 'false');
      });
      syncBodyState();
    }

    function syncBodyState() {
      const anyOpen = desktopMenus.some((details) => details.hasAttribute('open'));
      document.body.classList.toggle('dune-navigation-drawer-open', anyOpen);
      document.body.classList.toggle('overflow-hidden', anyOpen);
    }

    desktopMenus.forEach((details) => {
      details.addEventListener('toggle', () => {
        window.clearTimeout(details.duneOpeningTimer);
        if (details.hasAttribute('open')) {
          closeDesktopMenus(details);
          details.duneOpeningTimer = window.setTimeout(() => {
            if (!details.hasAttribute('open')) return;
            details.classList.add('dune-desktop-drawer-opening');
            syncBodyState();
          }, 90);
        } else {
          details.classList.remove('dune-desktop-drawer-opening');
          syncBodyState();
        }
      });
    });

    document.addEventListener('click', (event) => {
      if (!document.body.classList.contains('dune-navigation-drawer-open')) return;
      if (event.target.closest('.dune-sophie-header .header__inline-menu header-menu')) return;
      closeDesktopMenus();
    });

    document.addEventListener('keyup', (event) => {
      if (event.code && event.code.toUpperCase() === 'ESCAPE') {
        closeDesktopMenus();
        const mobileDrawer = document.querySelector('header-drawer');
        const mobileDrawerDetails = document.querySelector('#Details-menu-drawer-container[open]');
        if (mobileDrawer && mobileDrawerDetails && typeof mobileDrawer.closeMenuDrawer === 'function') {
          mobileDrawer.closeMenuDrawer(event, mobileDrawerDetails.querySelector('summary'));
        }
      }
    });

    window.addEventListener('resize', () => closeDesktopMenus());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSophieNavigation);
  } else {
    initSophieNavigation();
  }
})();
